import { atomWithReset } from "jotai/utils";

export const isPathActiveAtom = atomWithReset(false);
